function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".minimize_svg__cls-4{fill:none}.minimize_svg__cls-3{stroke:none}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "minimize_svg__Rectangle_7996",
  fill: "none",
  stroke: "#797979"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  className: "minimize_svg__cls-3",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  x: 0.5,
  y: 0.5,
  className: "minimize_svg__cls-4",
  rx: 2.5
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "minimize_svg__Rectangle_7997",
  fill: "#797979",
  stroke: "#797979",
  transform: "translate(4 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h7v1H0z",
  className: "minimize_svg__cls-3"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  x: 0.5,
  y: 0.5,
  className: "minimize_svg__cls-4"
}));
function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "minimize_svg__Component_114_168",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref, _ref2, _ref3);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_114_168' width='15' height='15' viewBox='0 0 15 15'%3e %3cdefs%3e %3cstyle%3e .cls-4%7bfill:none%7d.cls-3%7bstroke:none%7d %3c/style%3e %3c/defs%3e %3cg id='Rectangle_7996' fill='none' stroke='%23797979'%3e %3crect width='15' height='15' class='cls-3' rx='3'/%3e %3crect width='14' height='14' x='.5' y='.5' class='cls-4' rx='2.5'/%3e %3c/g%3e %3cg id='Rectangle_7997' fill='%23797979' stroke='%23797979' transform='translate(4 10)'%3e %3cpath d='M0 0H7V1H0z' class='cls-3'/%3e %3crect width='6' x='.5' y='.5' class='cls-4'/%3e %3c/g%3e %3c/svg%3e";
export { SvgMinimize as ReactComponent };